<template>
  <AuthWrapper>
    <div class="version-info">
      <p>{{ version }}</p>
    </div>

    <!-- <p class="auth-notice">Don&rsquo;t have an account? <router-link to="/auth/register">Sign up now</router-link></p> -->
    <div class="auth-contents">
      <a-form @finish="handleSubmit" :model="formState" layout="vertical" :rules="rules" autocomplete="off">
        <sdHeading as="h3"> Sign in to <span class="color-primary">KEEPInsight</span> </sdHeading>
        <a-form-item name="email" label="Email">
          <a-input type="email" v-model:value="formState.email" placeholder="Masukkan Email" autofocus />
        </a-form-item>
        <!-- <a-form-item name="password" label="Password">
          <a-input-password type="password" v-model:value="formState.password" placeholder="Masukkan Password" />
        </a-form-item> -->
        <a-form-item name="custom_password" label="Password">
          <a-input-password
            type="password"
            v-model:value="formState.password"
            placeholder="Masukkan Password"
            autocomplete="new-password"
          />
        </a-form-item>

        <div class="auth-form-action">
          <!-- <a-checkbox @change="onChange">Keep me logged in</a-checkbox> -->
          <router-link class="forgot-pass-link" to="/auth/forgot-password">
            Lupa Password?
          </router-link>
        </div>
        <a-form-item>
          <sdButton class="btn-signin btn-primary" htmlType="submit" type="primary" size="large">
            {{ isLoading ? 'Harap Menuggu...' : 'Sign In' }}
          </sdButton>
        </a-form-item>
        <!-- <a-form-item>
          <router-link to="/auth-assessment/login">
            <sdButton class="btn-signin btn-primary" type="primary" size="large">
              Assessment
            </sdButton>
          </router-link>
        </a-form-item> -->
        <a-form-item>
          <div class="divider">
            <span>or sign in with</span>
          </div>
        </a-form-item>
        <a-form-item>
          <button class="btn-signin btn-microsoft" @click="loginWithAzure" type="button" size="large">
            <img :src="microsoftLogo" alt="Microsoft Logo" class="microsoft-logo" />
            SSO Login PLNEPI
          </button>
        </a-form-item>
        <a-form-item>
          <div class="divider">
            <span>or</span>
          </div>
        </a-form-item>
        <!-- <a-form>
          <div class="auth0-login">
            <router-link to="/auth-assessment/login">
              <UserSwitchOutlined style="margin-right: 8px" /> Login Pembinaan Person Grade
            </router-link>
          </div>
        </a-form> -->
        <a-form-item>
          <router-link to="/auth-assessment/login">
            <sdButton class="btn-signin btn-primary" htmlType="submit" type="primary" size="large">
              <UserSwitchOutlined style="margin-right: 8px" /> Login Pembinaan Person Grade
            </sdButton>
          </router-link>
        </a-form-item>
        <!-- <p class="form-divider"> -->
        <!--   <span>Or</span> -->
        <!-- </p> -->
        <!-- <ul class="social-login"> -->
        <!--   <li> -->
        <!--     <a class="google-signup" href="#"> -->
        <!--       <img :src="require('@/static/img/google.png')" alt="" /> -->
        <!--       <span>Sign in with Google</span> -->
        <!--     </a> -->
        <!--   </li> -->
        <!--   <li> -->
        <!--     <a class="facebook-sign" href="#"> -->
        <!--       <FacebookOutlined /> -->
        <!--     </a> -->
        <!--   </li> -->
        <!--   <li> -->
        <!--     <a class="twitter-sign" href="#"> -->
        <!--       <TwitterOutlined /> -->
        <!--     </a> -->
        <!--   </li> -->
        <!-- </ul> -->
        <!-- <div class="auth0-login"> -->
        <!--   <a href="#" @click="() => lock.show()"> -->
        <!--     Sign In with Auth0 -->
        <!--   </a> -->
        <!-- </div> -->
      </a-form>
    </div>
  </AuthWrapper>
</template>
<script>
// import { FacebookOutlined, TwitterOutlined } from '@ant-design/icons-vue';
import { UserSwitchOutlined } from '@ant-design/icons-vue';
import { computed, reactive, onMounted } from 'vue';
import { useStore } from 'vuex';
import { AuthWrapper } from './style';
import microsoftLogo from '@/static/img/icon/Microsoft_logo.svg';
// import { useRouter } from 'vue-router';
// import { Auth0Lock } from 'auth0-lock';
// import { auth0options } from '@/config/auth0';

// const domain = process.env.VUE_APP_AUTH0_DOMAIN;
// const clientId = process.env.VUE_APP_AUTH0_CLIENT_ID;

const SignIn = {
  name: 'SignIn',
  components: {
    // FacebookOutlined,
    // TwitterOutlined,
    AuthWrapper,
    UserSwitchOutlined,
  },
  setup() {
    const version = process.env.VUE_APP_VERSION || 'v1.0.0';
    const { state, dispatch } = useStore();
    const isLoading = computed(() => state.auth.loading);
    // const checked = ref(null);
    // const router = useRouter();

    const handleSubmit = () => {
      const user = {
        email: formState.email,
        password: formState.password,
      };

      /* router.push('/'); */
      dispatch('login', user);
    };

    const loginWithAzure = () => {
      window.location.href = process.env.VUE_APP_AZURE_LOGIN_URL;
    };

    // const onChange = checked => {
    //   checked.value = checked;
    // };

    const rules = {
      email: [
        {
          required: true,
          message: 'Harap Diisi',
          trigger: 'blur',
        },
      ],
      password: [
        {
          required: true,
          message: 'Harap Diisi',
          trigger: 'blur',
        },
      ],
    };

    const formState = reactive({
      email: '',
      password: '',
    });

    // const lock = new Auth0Lock(clientId, domain, auth0options);

    // lock.on('authenticated', authResult => {
    //   lock.getUserInfo(authResult.accessToken, (error) => {
    //     if (error) {
    //       return;
    //     }

    //     handleSubmit();
    //     lock.hide();
    //   });
    // });

    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');

      if (token) {
        // Panggil action loginToken di Vuex
        dispatch('loginToken', token);
      }
    });

    return {
      isLoading,
      // checked,
      handleSubmit,
      loginWithAzure,
      // onChange,
      formState,
      // lock,
      rules,
      microsoftLogo,
      version,
    };
  },
};

export default SignIn;
</script>

<style scoped>
.microsoft-logo {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.btn-microsoft {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f2f1;
  color: #000;
  border: 1px solid #8a8886;
  padding: 10px;
}

.btn-microsoft:hover {
  background-color: #e1dfdd;
  border-color: #605e5c;
}

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 10px 0;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #ccc;
}

.divider:not(:empty)::before {
  margin-right: 0.25em;
}

.divider:not(:empty)::after {
  margin-left: 0.25em;
}

.version-info {
  text-align: right;
  font-size: 12px;
  color: #888;
}
</style>
